interface MenuItemsInitialState {
  dashboard?: boolean;
  designPage?: boolean;
  recent?: boolean;
  master?: boolean;
  operations?: boolean;
  ftl?: boolean;
  operationSubMenu?: {
    firstMile?: boolean;
    middleMile?: boolean;
    lastMile?: boolean;
  };
  sales?: boolean;
  salesSubMenu?: {
    leads?: boolean;
    myLeads?: boolean;
    activity?: boolean;
    myActivity?: boolean;
    reports?: boolean;
    expense?: boolean;
    myExpense?: boolean;
    createSalesExpense?: boolean;
    salesFunnel?: boolean;
  };
  hr?: boolean;
  hrSubMenu?: {
    attendanceManagement?: boolean;
    attendanceReport?: boolean;
    leaveManagement?: boolean;
    payrollManagement?: boolean;
    myLeaves?: boolean;
    myAttendance?: boolean;
    role?: boolean;
    department?: boolean;
    user?: boolean;
  };
  account?: boolean;
  accountSubMenu?: {
    users?: boolean;
    bank?: boolean;
    rates?: boolean;
  };
  shipment?: boolean;
  shipmentSubMenu?: {
    shipment1?: boolean;
  };
  permission?: boolean;
  permissionSubMenu?: {
    permission?: boolean;
    permissionRole?: boolean;
    section?: boolean;
    departmentSection?: boolean;
  };
}

export enum MenuItems {
  DASHBOARD = "DASHBOARD",
  DESIGN_PAGE = "DESIGN_PAGE",
  RECENT = "RECENT",
  MASTER = "MASTER",

  OPERATIONS = "OPERATIONS",
  FIRST_MILE = "FIRST_MILE",
  MIDDLE_MILE = "MIDDLE_MILE",
  LAST_MILE = "LAST_MILE",

  FTL = "FTL",

  SALES = "SALES",
  LEADS = "LEADS",
  MY_LEADS = "MY_LEADS",
  ACTIVITY = "ACTIVITY",
  MY_ACTIVITY = "MY_ACTIVITY",
  REPORTS = "REPORTS",
  SALES_EXPENSE_LIST = "SALES_EXPENSE_LIST",
  MY_SALES_EXPENSE_LIST = "MY_SALES_EXPENSE_LIST",
  CREATE_SALES_EXPENSE = "CREATE_SALES_EXPENSE",
  SALES_FUNNEL = "SALES_FUNNEL",

  HR = "HR",
  ATTENDANCE_MANAGEMENT = "ATTENDANCE_MANAGEMENT",
  ATTENDANCE_REPORT = "ATTENDANCE_REPORT",
  PAYROLL_MANAGEMENT = "PAYROLL_MANAGEMENT",
  LEAVE_MANAGEMENT = "LEAVE_MANAGEMENT",
  MY_LEAVES = "MY_LEAVES",
  MY_ATTENDANCE = "MY_ATTENDANCE",
  ROLE = "ROLE",
  DEPARTMENT = "DEPARTMENT",
  USER = "USER",


  ACCOUNTS = "ACCOUNTS",
  USERS = "USERS",
  BANK = "BANK",
  RATES = "RATES",

  SHIPMENT = "SHIPMENT",
  SHIPMENT1 = "SHIPMENT1",

  PERMISSIONS = "PERMISSIONS",
  PERMISSION = "PERMISSION",
  PERMISSION_ROLE = "PERMISSION_ROLE",
  SECTION = "SECTION",
  DEPARTMENT_SECTION = "DEPARTMENT_SECTION",
}

interface MenuActions {
  type: MenuItems;
}

export const menuOptionsInitialState: MenuItemsInitialState = {
  dashboard: false,
  designPage: false,
  recent: false,
  master: false,
  operations: false,
  ftl: false,
  operationSubMenu: {
    firstMile: false,
    middleMile: false,
    lastMile: false,
  },
  sales: false,
  salesSubMenu: {
    leads: false,
    myLeads: false,
    activity: false,
    myActivity: false,
    reports: false,
    expense: false,
    myExpense: false,
    createSalesExpense: false,
    salesFunnel: false,
  },
  hr: false,
  hrSubMenu: {
    attendanceManagement: false,
    attendanceReport: false,
    payrollManagement: false,
    leaveManagement: false,
    myLeaves: false,
    myAttendance: false,
    role: false,
    department: false,
    user: false
  },
  account: false,
  accountSubMenu: {
    users: false,
    bank: false,
    rates: false

  },
  shipment: false,
  shipmentSubMenu: {
    shipment1: false,
  },
  permission: false,
  permissionSubMenu: {
    permission: false,
    permissionRole: false,
    section: false,
    departmentSection: false,
  },
};

export const menuReducer = (state: MenuItemsInitialState, action: MenuActions): any => {
  switch (action.type) {
    case MenuItems.DASHBOARD:
      return {
        dashboard: !state.dashboard,
      };
    case MenuItems.DESIGN_PAGE:
      return {
        designPage: !state.designPage,
      };

    case MenuItems.RECENT:
      return {
        recent: !state.recent,
      };

    case MenuItems.MASTER:
      return {
        master: !state.master,
      };

    case MenuItems.OPERATIONS:
      return {
        operations: !state.operations,
      };

    case MenuItems.FIRST_MILE:
      return {
        operations: true,
        operationSubMenu: {
          firstMile: !state.operationSubMenu?.firstMile,
        },
      };

    case MenuItems.MIDDLE_MILE:
      return {
        operations: true,
        operationSubMenu: {
          middleMile: !state.operationSubMenu?.middleMile,
        },
      };

    case MenuItems.LAST_MILE:
      return {
        operations: true,
        operationSubMenu: {
          lastMile: !state.operationSubMenu?.lastMile,
        },
      };

    case MenuItems.FTL:
      return {
        ftl: !state.ftl,
      }

    case MenuItems.SALES:
      return {
        sales: !state.sales,
      };

    case MenuItems.LEADS:
      return {
        sales: true,
        salesSubMenu: {
          leads: !state.salesSubMenu?.leads,
        },
      };

    case MenuItems.ACTIVITY:
      return {
        sales: true,
        salesSubMenu: {
          activity: !state.salesSubMenu?.activity,
        },
      };

    case MenuItems.MY_ACTIVITY:
      return {
        sales: true,
        salesSubMenu: {
          myActivity: !state.salesSubMenu?.myActivity,
        },
      };

    case MenuItems.REPORTS:
      return {
        sales: true,
        salesSubMenu: {
          reports: !state.salesSubMenu?.reports,
        },
      };

    case MenuItems.SALES_EXPENSE_LIST:
      return {
        sales: true,
        salesSubMenu: {
          expense: !state.salesSubMenu?.expense,
        },
      };

    case MenuItems.MY_SALES_EXPENSE_LIST:
      return {
        sales: true,
        salesSubMenu: {
          myExpense: !state.salesSubMenu?.myExpense,
        },
      };

    case MenuItems.CREATE_SALES_EXPENSE:
      return {
        sales: true,
        salesSubMenu: {
          createSalesExpense: !state.salesSubMenu?.createSalesExpense,
        },
      };

    case MenuItems.SALES_FUNNEL:
      return {
        sales: true,
        salesSubMenu: {
          salesFunnel: !state.salesSubMenu?.salesFunnel,
        },
      };

    case MenuItems.HR:
      return {
        hr: !state.hr,
      };

    case MenuItems.ATTENDANCE_MANAGEMENT:
      return {
        hr: true,
        hrSubMenu: {
          attendanceManagement: !state.hrSubMenu?.attendanceManagement,
        },
      };
    case MenuItems.ROLE:
      return {
        hr: true,
        hrSubMenu: {
          role: !state.hrSubMenu?.role,
        },
      };

    case MenuItems.DEPARTMENT:
      return {
        hr: true,
        hrSubMenu: {
          department: !state.hrSubMenu?.department,
        },
      };

    case MenuItems.USER:
      return {
        hr: true,
        hrSubMenu: {
          user: !state.hrSubMenu?.user,
        },
      };
    case MenuItems.PAYROLL_MANAGEMENT:
      return {
        hr: true,
        hrSubMenu: {
          payrollManagement: !state.hrSubMenu?.payrollManagement,
        },
      };

    case MenuItems.ATTENDANCE_REPORT:
      return {
        hr: true,
        hrSubMenu: {
          attendanceReport: !state.hrSubMenu?.attendanceReport,
        },
      };

    case MenuItems.LEAVE_MANAGEMENT:
      return {
        hr: true,
        hrSubMenu: {
          leaveManagement: !state.hrSubMenu?.leaveManagement,
        },
      };

    case MenuItems.MY_LEAVES:
      return {
        hr: true,
        hrSubMenu: {
          myLeaves: !state.hrSubMenu?.myLeaves,
        },
      };

    case MenuItems.MY_ATTENDANCE:
      return {
        hr: true,
        hrSubMenu: {
          myAttendance: !state.hrSubMenu?.myAttendance,
        },
      };

    case MenuItems.ACCOUNTS:
      return {
        account: !state.account,
      };

    case MenuItems.USERS:
      return {
        account: true,
        accountSubMenu: {
          users: !state.accountSubMenu?.users,
        },
      };

    case MenuItems.BANK:
      return {
        ...state,
        account: true,
        accountSubMenu: {
          ...state.accountSubMenu,
          bank: !state.accountSubMenu?.bank
        }
      };

    case MenuItems.RATES:
      return {
        ...state,
        account: true,
        accountSubMenu: {
          ...state.accountSubMenu,
          rates: !state.accountSubMenu?.rates
        }
      };

    case MenuItems.SHIPMENT:
      return {
        shipment: !state.shipment,
      };

    case MenuItems.SHIPMENT1:
      return {
        shipment: true,
        shipmentSubMenu: {
          shipment1: !state.shipmentSubMenu?.shipment1,
        },
      };

    case MenuItems.PERMISSIONS:
      return {
        permission: !state.permission,
      };

    case MenuItems.PERMISSION:
      return {
        permission: true,
        permissionSubMenu: {
          permission: !state.permissionSubMenu?.permission,
        },
      };

    case MenuItems.PERMISSION_ROLE:
      return {
        permission: true,
        permissionSubMenu: {
          permissionRole: !state.permissionSubMenu?.permissionRole,
        },
      };

    case MenuItems.SECTION:
      return {
        permission: true,
        permissionSubMenu: {
          section: !state.permissionSubMenu?.section,
        },
      };

    case MenuItems.DEPARTMENT_SECTION:
      return {
        permission: true,
        permissionSubMenu: {
          departmentSection: !state.permissionSubMenu?.departmentSection,
        },
      };

    default:
      return state;
  }
};
